import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import logo from 'assets/img/logo-white.png'

import config from 'config'
// import { get } from 'lodash'

// import { apiConfiguration } from 'helpers/decorators/api'
// import { CONFIGURATION_KEYS } from 'constants/enums'

// move to containers

// @apiConfiguration()
export default class Logo extends Component {
  static propTypes = {
    to: PropTypes.string
    // configuration: PropTypes.object.isRequired
    // getConfigurationKeyValue: PropTypes.func.isRequired
  }

  static defaultProps = {
    to: `${config.publicPath}/`
  }

  // componentDidMount = () =>
  //   this.props.getConfigurationKeyValue(CONFIGURATION_KEYS.aboutAwardUrl.id)

  render() {
    // const { configuration } = this.props

    // const aboutAwardUrl = get(
    //   configuration,
    //   `values[${CONFIGURATION_KEYS.aboutAwardUrl.id}].textValue`
    // )

    const LogoElement = (
      <img
        src={logo}
        height={42}
        alt="Duke of Edinburgh"
      />
    )

    return <Link to={this.props.to}>{LogoElement}</Link>
  }
}
